module.exports = __webpack_public_path__ + "static/media/HeroBackground-Option3-01.0cd4999f.png";